function initCustomQuantitySelector() {
  const selectors = document.querySelectorAll('.bk-media-custom-quantity-selector');
  
  selectors.forEach(selector => {
    const optionsScript = selector.querySelector('[data-quantity-options]');
    if (!optionsScript) return;
    
    let optionsData;
    try {
      optionsData = JSON.parse(optionsScript.textContent);
    } catch (e) {
      console.error('Failed to parse quantity options:', e);
      return;
    }
    
    const quantityInput = selector.querySelector('.bk-media-quantity-input');
    const options = selector.querySelectorAll('.bk-media-quantity-option');
    const displayMode = optionsData.displayMode || 'dropdown';
    const isInline = displayMode === 'inline';
    const selectedImage = selector.querySelector('.bk-media-selected-image');
    const selectedLabel = selector.querySelector('.bk-media-selected-label');
    const selectedPrice = selector.querySelector('.bk-media-selected-price');
    const currentPriceEl = selector.querySelector('.bk-media-current-price');
    const comparePriceEl = selector.querySelector('.bk-media-compare-price');
    const discountBadge = selector.querySelector('.bk-media-discount-badge');
    const unitPriceEl = selector.querySelector('.bk-media-quantity-unit-price-value');
    
    function calculatePrices(option) {
      const basePrice = optionsData.basePrice;
      const compareAtPrice = optionsData.compareAtPrice;
      const shakesPerUnit = optionsData.shakesPerUnit;
      const quantity = option.quantity;
      const discount = option.discount;
      
      const unitDiscountAmount = Math.floor(basePrice * discount / 100);
      const unitFinalPrice = basePrice - unitDiscountAmount;
      const finalPrice = unitFinalPrice * quantity;
      const totalPrice = basePrice * quantity;
      const totalShakes = quantity * shakesPerUnit;
      const pricePerShake = finalPrice / totalShakes;
      
      let displayCompareAtPrice = 0;
      if (compareAtPrice > 0) {
        displayCompareAtPrice = compareAtPrice * quantity;
      } else if (discount > 0) {
        displayCompareAtPrice = totalPrice;
      }
      
      const unitPriceCents = optionsData.unitPrice || 0;
      const unitPriceAfterDiscount = unitPriceCents > 0
        ? Math.floor(unitPriceCents * (100 - discount) / 100)
        : 0;

      return {
        finalPrice,
        compareAtPrice: displayCompareAtPrice,
        pricePerShake,
        unitPricePerMeasurement: unitPriceAfterDiscount,
        discount
      };
    }
    
    function formatMoney(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(cents / 100);
    }
    
    function updateSelection(selectedOption) {
      options.forEach(opt => {
        opt.classList.remove('is-selected');
        opt.style.display = '';
      });
      selectedOption.classList.add('is-selected');
      if (!isInline) {
        selectedOption.style.display = 'none';
      }
      
      const optionIndex = parseInt(selectedOption.dataset.optionIndex);
      const option = optionsData.options[optionIndex];
      
      if (!option) return;
      
      const prices = calculatePrices(option);
      
      quantityInput.value = option.quantity;
      
      if (selectedImage) {
        if (option.image) {
          selectedImage.innerHTML = `<img src="${option.image}" alt="${option.label}" width="100" height="100" loading="lazy">`;
        } else {
          selectedImage.innerHTML = '';
        }
      }
      
      if (selectedLabel) selectedLabel.textContent = option.label;
      if (selectedPrice) selectedPrice.textContent = `${formatMoney(prices.pricePerShake)} /Shake`;
      
      const isOnSale = prices.compareAtPrice > prices.finalPrice || prices.discount > 0;
      
      currentPriceEl.textContent = formatMoney(prices.finalPrice);
      
      if (isOnSale) {
        currentPriceEl.classList.add('text-on-sale');
      } else {
        currentPriceEl.classList.remove('text-on-sale');
      }
      
      if (prices.compareAtPrice > prices.finalPrice) {
        comparePriceEl.textContent = formatMoney(prices.compareAtPrice);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
      
      if (discountBadge) discountBadge.style.display = 'none';

      if (unitPriceEl && prices.unitPricePerMeasurement > 0) {
        const unitRefUnit = optionsData.unitRefUnit || 'kg';
        const priceStr = formatMoney(prices.unitPricePerMeasurement).replace(/\s/g, '');
        unitPriceEl.textContent = `${priceStr}/${unitRefUnit}, inkl. MwSt. zzgl. Versandkosten`;
        unitPriceEl.closest('.bk-media-quantity-unit-price-row').style.display = '';
      } else if (unitPriceEl) {
        unitPriceEl.closest('.bk-media-quantity-unit-price-row').style.display = 'none';
      }
    }
    
    options.forEach((optionEl) => {
      optionEl.addEventListener('click', () => {
        updateSelection(optionEl);
        const details = selector.querySelector('details');
        if (details && details.open) {
          details.removeAttribute('open');
        }
      });
    });
    
    let targetOption = selector.querySelector('.bk-media-quantity-option.is-selected');
    if (!targetOption && options.length > 0) {
      const preselectIndex = Math.min(
        Math.max(0, optionsData.preselectIndex ?? 1),
        options.length - 1
      );
      targetOption = options[preselectIndex];
    }
    if (targetOption) {
      updateSelection(targetOption);
    }
  });
}

function initComparisonTabsAlignment() {
  const tables = document.querySelectorAll('.bk-media-comparison-tabs__table');
  
  tables.forEach(table => {
    const itemsContainers = table.querySelectorAll('.bk-media-comparison-tabs__items');
    if (itemsContainers.length < 2) return;
    
    const criteriaContainer = itemsContainers[0];
    const leftContainer = itemsContainers[1];
    const rightContainer = itemsContainers[2];
    
    if (!leftContainer || !rightContainer) return;
    
    const criteriaItems = criteriaContainer ? criteriaContainer.querySelectorAll('.bk-media-comparison-tabs__criteria-item') : [];
    const leftItems = leftContainer.querySelectorAll('.bk-media-comparison-tabs__item');
    const rightItems = rightContainer.querySelectorAll('.bk-media-comparison-tabs__item');
    
    const maxLength = Math.max(criteriaItems.length, leftItems.length, rightItems.length);
    
    for (let i = 0; i < maxLength; i++) {
      const rowItems = [];
      if (criteriaItems[i]) rowItems.push(criteriaItems[i]);
      if (leftItems[i]) rowItems.push(leftItems[i]);
      if (rightItems[i]) rowItems.push(rightItems[i]);
      
      if (rowItems.length > 1) {
        let maxHeight = 0;
        rowItems.forEach(item => {
          item.style.height = 'auto';
          const height = item.offsetHeight;
          if (height > maxHeight) maxHeight = height;
        });
        
        if (maxHeight > 0) {
          rowItems.forEach(item => {
            item.style.height = maxHeight + 'px';
          });
        }
      }
    }
  });
}

let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initComparisonTabsAlignment, 100);
});

document.addEventListener('DOMContentLoaded', () => {
  initCustomQuantitySelector();
  initComparisonTabsAlignment();
});

function initSlideshowUSPRotation() {
  const uspContainers = document.querySelectorAll('[data-slideshow-usps]');
  
  uspContainers.forEach(container => {
    const items = Array.from(container.querySelectorAll('.slideshow__usp-item'));
    if (items.length <= 1) return;
    
    let currentIndex = 0;
    let intervalId = null;
    
    function findCurrentIndex() {
      const activeIndex = items.findIndex(item => item.classList.contains('active'));
      return activeIndex >= 0 ? activeIndex : 0;
    }
    
    function showUSP(index) {
      items.forEach((item, i) => {
        if (i === index) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });
    }
    
    function nextUSP() {
      currentIndex = (currentIndex + 1) % items.length;
      showUSP(currentIndex);
    }
    
    function startRotation() {
      if (window.innerWidth <= 699) {
        if (!intervalId) {
          currentIndex = findCurrentIndex();
          intervalId = setInterval(nextUSP, 3000);
        }
      } else {
        if (intervalId) {
          clearInterval(intervalId);
          intervalId = null;
        }
        items.forEach(item => item.classList.add('active'));
      }
    }
    
    function stopRotation() {
      if (intervalId) {
        clearInterval(intervalId);
        intervalId = null;
      }
    }
    
    startRotation();
    
    window.addEventListener('resize', () => {
      stopRotation();
      startRotation();
    });
    
    container.addEventListener('mouseenter', stopRotation);
    container.addEventListener('mouseleave', startRotation);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initSlideshowUSPRotation();
});

document.addEventListener('shopify:section:load', () => {
  initCustomQuantitySelector();
  setTimeout(initComparisonTabsAlignment, 100);
  setTimeout(initSlideshowUSPRotation, 100);
});

document.addEventListener('variant:change', () => {
  setTimeout(initCustomQuantitySelector, 100);
});

document.addEventListener('product:rerender', () => {
  setTimeout(initCustomQuantitySelector, 100);
});

let accordionScrollObserver = null;

function initAccordionScroll() {
  if (accordionScrollObserver) {
    accordionScrollObserver.disconnect();
    accordionScrollObserver = null;
  }
  
  accordionScrollObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        const accordion = mutation.target;
        if (accordion.hasAttribute('open') && accordion.matches('details[is="accordion-disclosure"]')) {
          setTimeout(() => {
            const rect = accordion.getBoundingClientRect();
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const targetPosition = rect.top + scrollTop - 20;
            
            window.scrollTo({
              top: targetPosition,
              behavior: 'smooth'
            });
          }, 100);
        }
      }
    });
  });
  
  accordionScrollObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['open'],
    subtree: true
  });
}

document.addEventListener('click', (event) => {
  const removeBtn = event.target.closest('.bk-media-remove-button');
  if (!removeBtn || removeBtn.tagName !== 'A' || !removeBtn.href.includes('/cart/change')) return;
  if (!document.getElementById('cart-drawer')?.contains(removeBtn)) return;
  
  event.preventDefault();
  const url = new URL(removeBtn.href);
  const lineKey = url.searchParams.get('id');
  const quantity = parseInt(url.searchParams.get('quantity') || '0', 10);
  
  let sectionsToBundle = [];
  document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));
  if (sectionsToBundle.length === 0) {
    const cartDrawer = document.getElementById('cart-drawer');
    const sectionId = cartDrawer?.getAttribute('data-section-id') || 'cart-drawer';
    sectionsToBundle.push(sectionId);
  }
  
  fetch(`${window.Shopify.routes.root}cart/change.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: lineKey, quantity, sections: sectionsToBundle })
  }).then(async (response) => {
    if (!response.ok) return;
    const cartContent = await response.json();
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'line-item:change', cart: cartContent }
    }));
    if (cartContent.item_count === 0) {
      const cartDrawer = document.getElementById('cart-drawer');
      if (cartDrawer && typeof cartDrawer.hide === 'function') cartDrawer.hide();
    }
  }).catch(console.error);
}, true);

document.addEventListener('DOMContentLoaded', () => {
  initAccordionScroll();
});

document.addEventListener('shopify:section:load', () => {
  setTimeout(initAccordionScroll, 100);
});

window.addEventListener('resize', () => {
  initAccordionScroll();
});

